import {
  formatPercentageValue,
  checkForNA,
  appendPercentage,
  formatValueWithMiddlewares,
  createKpiTileItem,
} from '../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { throughputLosses, throughputLossesPercentageDelta } = data;

    return createKpiTileItem(
      'Throughput Losses',
      formatPercentageValue(throughputLosses),
      throughputLossesPercentageDelta
        ? {
            isPositiveValue: throughputLossesPercentageDelta >= 0,
            text: formatValueWithMiddlewares(
              Math.abs(throughputLossesPercentageDelta),
              [checkForNA, appendPercentage]
            ).toString(),
            sideLabel: '',
            showArrow: throughputLossesPercentageDelta !== 0,
          }
        : []
    );
  },
};
